<p-dialog [visible]="true" [modal]="true" [draggable]="false" [resizable]="false"
  styleClass="!rounded-[2rem] overflow-hidden shadow-2xl" contentStyleClass="!p-0" (onHide)="close.emit()"
  [style]="{ width: '900px' }" [breakpoints]="{ '960px': '90vw' }">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full pr-8">
      <div class="flex flex-col gap-0.5">
        <h3 class="text-xl font-bold text-slate-800">
          {{ 'vincular_label' | translate }} {{ 'procedures_label' | translate }}
        </h3>
        <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          {{ selectedProcedures.length }} {{ 'procedures_label' | translate }} {{ 'selected' | translate }}
        </p>
      </div>
    </div>
  </ng-template>

  <div class="flex flex-col h-[700px] max-h-[85vh]">
    <div class="flex gap-8 p-8 flex-1 overflow-hidden pt-4">
      <!-- Left: Full List -->
      <div class="flex-1 flex flex-col gap-6 overflow-hidden">
        <div class="flex flex-col gap-2">
          <label class="text-xs font-black text-slate-400 uppercase tracking-widest ml-1">{{ 'common_search' | translate
            }}</label>
          <p-iconField iconPosition="left">
            <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
            <input pInputText [formControl]="searchControl" type="text"
              class="!w-full !rounded-2xl !bg-slate-50/50 !border-slate-100 !pl-12 !py-3 !text-sm focus:!ring-primary/10 focus:!border-primary transition-all shadow-sm"
              [placeholder]="'common_search' | translate" />
          </p-iconField>
        </div>

        <div class="flex-1 overflow-y-auto custom-scrollbar border border-slate-100 rounded-[2rem] bg-white p-2">
          <div *ngIf="loading" class="flex flex-col gap-3 p-2">
            <div *ngFor="let i of [1,2,3,4,5]" class="h-14 bg-slate-50 animate-pulse rounded-2xl w-full"></div>
          </div>

          <div *ngIf="!loading && availableProcedures.length === 0"
            class="flex flex-col items-center justify-center py-20 text-slate-400 gap-4">
            <div class="w-16 h-16 rounded-[2rem] bg-slate-50 flex items-center justify-center">
              <i class="pi pi-search text-2xl opacity-40"></i>
            </div>
            <span class="text-xs font-bold uppercase tracking-widest">{{ 'no_items_added' | translate }}</span>
          </div>

          <div *ngFor="let p of availableProcedures" (click)="toggleProcedure(p)"
            class="px-5 py-4 flex items-center justify-between cursor-pointer rounded-2xl hover:bg-slate-50 transition-all duration-200 mb-1 group">
            <div class="flex items-center gap-3">
              <div
                class="w-8 h-8 rounded-xl bg-primary/5 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all">
                <i class="pi pi-plus text-[10px]"></i>
              </div>
              <span class="text-sm font-bold text-slate-700">{{ p.procedure_name || p.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right: Selected List -->
      <div class="w-80 flex flex-col gap-6 overflow-hidden">
        <div class="flex flex-col gap-1">
          <h3
            class="font-black text-slate-900 text-sm uppercase tracking-widest flex items-center justify-between ml-1">
            {{ 'selected_procedures_label' | translate }}
            <span class="bg-primary text-white px-2.5 py-1 rounded-full text-[10px] font-black">{{
              selectedProcedures.length }}</span>
          </h3>
          <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-widest ml-1">{{ 'yes' | translate }}</p>
        </div>

        <div class="flex-1 overflow-y-auto custom-scrollbar bg-slate-50/50 rounded-[2rem] border border-slate-100 p-3">
          <div *ngIf="selectedProcedures.length === 0"
            class="flex flex-col items-center justify-center py-20 text-slate-400 gap-4">
            <div class="w-12 h-12 rounded-2xl border-2 border-dashed border-slate-200 flex items-center justify-center">
              <i class="pi pi-check text-slate-200"></i>
            </div>
            <p class="text-[10px] font-black uppercase tracking-widest text-center px-4">{{ 'no_items_added' | translate
              }}</p>
          </div>

          <div *ngFor="let p of selectedProcedures"
            class="bg-white px-5 py-4 rounded-2xl mb-2 flex items-center justify-between shadow-sm border border-slate-100 group animate-fadeIn">
            <span class="text-xs font-bold text-slate-700 flex-1 line-clamp-2">{{ p.procedure_name || p.description
              }}</span>
            <button (click)="removeSelected(p)"
              class="ml-3 w-7 h-7 flex items-center justify-center rounded-lg text-slate-300 hover:text-rose-500 hover:bg-rose-50 transition-all">
              <i class="pi pi-times text-[10px]"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="p-8 border-t border-slate-50 flex justify-end gap-4 shrink-0">
      <app-button [label]="'button_cancel' | translate" variant="secondary" (onClick)="close.emit()"
        class="flex-1 sm:flex-initial"></app-button>
      <app-button [label]="(saving ? ('saving' | translate) : ('button_save' | translate))" [loading]="saving"
        [disabled]="selectedProcedures.length === 0" (onClick)="save()"
        class="flex-1 sm:flex-initial min-w-[140px]"></app-button>
    </div>
  </div>
</p-dialog>